import "./ModalForm.scss";
import ReactModal from "react-modal";
import BorderCircle from "../BorderCircle/BorderCircle";
import ContactsForm from "../ContactsForm/ContactsForm";

ReactModal.setAppElement("#root");

const ModalForm = ({ isOpen, onClose }) => {
  return (
    <ReactModal
      isOpen={isOpen}
      onRequestClose={onClose}
      contentLabel="Форма"
      className="modalForm__window"
      overlayClassName="modalForm__overlay"
    >
      <BorderCircle>
        <div className="modalForm__content">
          <button
            className="modalForm__btn"
            type="button"
            onClick={onClose}
            aria-label="Кнопка закрытия"
          ></button>
          <h3 className="about__desc about__desc--xl about__desc--color">Оставьте свое сообщение!</h3>
          <p className="intro__description">Я свяжусь с вами в ближайшее время</p>
          <ContactsForm closeForm={onClose}/>
        </div>
      </BorderCircle>
    </ReactModal>
  );
};

export default ModalForm;